import IIdRef from '@src/model/common/IdRef';
import { IUserDetails } from '@src/model/user/UserDetails';

export interface INote {
  addedDateTime: string;
  id: string;
  object: IIdRef<string>;
  objectType: INoteObjectType;
  text: string;
  public?: boolean;
  createdBy: IUserDetails;
}
export enum NoteObjectTypeEnum {
  COURSE = '1',
  EXAM_TEMPLATE = '2',
  WEBINAR = '3',
  EDUCATION_APPLICATION = '4',
  EXTERNAL_EDUCATION_TEMPLATE = '5',
  USER = '6',
}
export interface INoteObjectType {
  id: NoteObjectTypeEnum;
  name: string;
}
